"use client";
import React from "react";

export default function Utilities() {

    const utilitiesData = [
        { name: "Enquire DIN Status (MCA FO Service)", url: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/enquire-din-status.html" },

        { name: "Check Last Annual Filing (MCA)", url: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/company-master-data.html" },

        { name: "Enquire GST Filing Status", url: "https://www.gst.gov.in/" },

        { name: "Search GST HSN", url: "https://services.gst.gov.in/services/searchhsn" },

        { name: "Income Tax Login", url: "https://www.incometax.gov.in/iec/foportal/" },

        { name: "TDS Login (TRACES)", url: "https://www.tdscpc.gov.in/app/login.xhtml" },

        { name: "BSE Listing Center Login", url: "https://listing.bseindia.com/" },

        { name: "FEMA FIRMS Login", url: "https://firms.icai.org/firms/" },

        // Extra services
        { name: "PAN Verification (NSDL)", url: "https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html" },

        { name: "TAN Verification", url: "https://tin.tin.nsdl.com/tan/StatusTrack.html" },

        { name: "GST Taxpayer Search", url: "https://services.gst.gov.in/services/searchtp" },

        { name: "LLP Master Data (MCA)", url: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/llp-master-data.html" },

        { name: "Director Master Data (MCA)", url: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/director-master-data.html" },

        { name: "ROC Company Name Check", url: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/check-company-name.html" },

        { name: "EPFO Member Passbook Login", url: "https://passbook.epfindia.gov.in/MemberPassBook/Login.jsp" }
    ];
    return (
        <div className="utilities-wrapper" style={{ padding: "120px 70px" }}>

            {/* HEADER BOX SAME AS CALCULATOR */}
            <div 
             className="utilities-header"
             style={{
                backgroundColor: "#eef2f6",
                padding: "20px 10px",
                borderRadius: "12px",
                textAlign: "center",
                marginBottom: "30px",
                border: "1px solid #d1d9e6",
                width: "100%"
            }}>
                <h2 style={{
                    margin: 0,
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#1a3c6e",
                    letterSpacing: "1px"
                }}>
                    UTILITIES & QUICK SERVICES
                </h2>

                <p style={{
                    marginTop: "4px",
                    fontSize: "14px",
                    color: "#4b5563",
                    fontWeight: "500"
                }}>
                    Access important government and compliance services quickly:
                </p>
            </div>

            {/* TABLE SAME STYLE */}
            <div style={{
                overflowX: "auto",
                border: "1px solid #ddd",
                borderRadius: "6px"
            }}>
                <table style={{
                    width: "100%",
                    minWidth: "600px",
                    borderCollapse: "collapse"
                }}>

                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                        <tr>
                            <th style={thStyle}>S. No.</th>
                            <th style={thStyle}>Service Name</th>
                            <th style={thStyle}>Website</th>
                        </tr>
                    </thead>

                    <tbody>
                        {utilitiesData.map((item, index) => (
                            <tr
                                key={index}
                                onMouseEnter={(e) => e.currentTarget.style.background = "#f9f9f9"}
                                onMouseLeave={(e) => e.currentTarget.style.background = "white"}
                            >
                                <td style={tdStyle}>{index + 1}</td>
                                <td style={tdStyle}>{item.name}</td>
                                <td style={{ ...tdStyle, wordBreak: "break-word" }}>
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#1a73e8" }}
                                    >
                                        {item.url}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
}

const thStyle = {
    padding: "12px",
    textAlign: "left",
    border: "1px solid #ddd",
    fontWeight: "600"
};

const tdStyle = {
    padding: "12px",
    border: "1px solid #ddd",
};